import cls from "classnames";
import { Modal } from "@bit-design/react";
import { FormattedMessage } from "components/FormattedMessage";
import { useUserPreferenceSetting } from "store/data/User";
import { getOriginalSite } from "helper";
import { LocaleSelector } from "store/data/Base";
import { atom, useRecoilState, useRecoilValue } from "recoil";

export const CostOrProfitModalState = atom({
  key: "spot-cost-profit-modal",
  default: false,
});
const CostOrProfitModal = () => {
  const [userPreference, updateUserPreference]: any =
    useUserPreferenceSetting(); // 用户配置 读取 更新
  const currentLocale = useRecoilValue(LocaleSelector);
  const [isModalOpen, setIsModalOpen] = useRecoilState(CostOrProfitModalState);
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const changeCostOrProfitPrice = (type) => {
    updateUserPreference({
      costOrProfitPrice: type,
    });
  };

  const goArticle = () => {
    let articleLink = getOriginalSite(
      `/academy/a-guide-to-cointr-spot-profit-and-loss-analysis`,
      currentLocale
    );
    if (!/zh-cn/gi.test(currentLocale))
      articleLink = articleLink.replace(currentLocale + "/", "");
    window.open(articleLink);
  };

  return (
    <Modal
      title={
        <FormattedMessage
          id={"spot_margin_position_pl.spot_pnl.modal_title"}
          defaultMessage="Select price type"
        />
      }
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footerInline
      data-testid="test-modal"
      footer={null}
      zIndex={999}
    >
      <div
        className={cls(
          "p-[16px] text-primaryText border-[1px] border-solid border-[var(--ds-color-border-strong)] rounded-[8px] mb-[12px] cursor-pointer",
          {
            "!border-[var(--cointr-color-text1)]":
              userPreference?.costOrProfitPrice === 1,
          }
        )}
        onClick={() => {
          changeCostOrProfitPrice(1);
        }}
      >
        <span className="font-[600] text-[16px] leading-[22px] h-[22px] phone:text-[18px] phone:h-[25px] phone:leading-[25px]">
          <FormattedMessage
            id={"spot_margin_position_pl.spot_pnl.modal_profit_price_title"}
            defaultMessage="Breakeven price – trade"
          />
        </span>
        <div className="text-[14px] font-[400] mt-[8px] phone:text-[var(--ds-color-text-tertiary)]">
          <span>
            <FormattedMessage
              id={"spot_margin_position_pl.spot_pnl.modal_profit_price_content"}
              defaultMessage="Breakeven price = (initial position size × initial breakeven price + change in position size × price during the change) ÷ (initial position size + change in position size)"
            />
          </span>
          <div className="phone:mt-[8px]">
            <FormattedMessage
              id={
                "spot_margin_position_pl.spot_pnl.modal_profit_price_content1"
              }
              defaultMessage="Trading data generated after September 19, 2024, 10:15:44 AM (UTC+8)."
            />
          </div>
        </div>
      </div>

      <div
        className={cls(
          "p-[16px] text-primaryText border-[1px] border-solid border-[var(--ds-color-border-strong)] rounded-[8px] mb-[12px] cursor-pointer",
          {
            "!border-[var(--cointr-color-text1)]":
              userPreference?.costOrProfitPrice === 0,
          }
        )}
        onClick={() => {
          changeCostOrProfitPrice(0);
        }}
      >
        <span className="font-[600] text-[16px] leading-[22px] h-[22px] phone:text-[18px] phone:h-[25px] phone:leading-[25px]">
          <FormattedMessage
            id={"spot_margin_position_pl.spot_pnl.modal_cost_price_title"}
            defaultMessage="Cost price – asset"
          />
        </span>
        <div className="text-[14px] font-[400] mt-[8px] phone:text-[var(--ds-color-text-tertiary)]">
          <span>
            <FormattedMessage
              id={"spot_margin_position_pl.spot_pnl.modal_cost_price_content"}
              defaultMessage="Cost price = (initial position size × initial cost price + increment × price at the time of increment) ÷ (initial position size + increment)"
            />
          </span>
          <div className="phone:mt-[8px]">
            <FormattedMessage
              id={"spot_margin_position_pl.spot_pnl.modal_cost_price_content1"}
              defaultMessage="Trading data generated after August 28, 2023, 8:00 AM (UTC+8)."
            />
          </div>
        </div>
      </div>
      <div className="mt-[12px] text-[12px] phone:text-[14px]">
        <span className="text-[var(--ds-color-text-tertiary)] phone:text-[var(--content-primary)]">
          <FormattedMessage
            id={"spot_margin_position_pl.spot_pnl.more_tip"}
            defaultMessage="To learn more about spot PnL analysis, click "
          />
        </span>
        <span
          className="text-[var(--content-link-default)] cursor-pointer"
          onClick={goArticle}
        >
          <FormattedMessage
            id={"spot_margin_position_pl.spot_pnl.more_btn"}
            defaultMessage="View more"
          />
        </span>
      </div>
    </Modal>
  );
};

export default CostOrProfitModal;
